import { CampaignRecipient } from "@dev/ee-api/ee-api-models";
import React, { useRef, useState, useEffect } from "react";
import { includes } from "lodash";
import { palette } from "@dev/ee-components";
import { PaidNewsletterIcon } from "@dev/ee-components";
import { useCustomIsMobile } from "@/services/hooks/useCustomIsMobile";
import { RecipientsContainer, RecipientText, RecipientEllipsis } from "./styledComponents";
    
export const CampaignRecipients = ({ targets }: { targets: CampaignRecipient }) => {
    const textRef = useRef<HTMLSpanElement>(null);
    const [isTextTruncated, setIsTextTruncated] = useState(false);
    const isMobile = useCustomIsMobile();
    
    const listNames = targets?.ListNames || [];
    const segmentNames = targets?.SegmentNames || [];
    const paidListNames = targets?.PaidListNames || [];
    
    const allRecipients = [...listNames, ...segmentNames];
    const hasMultipleItems = allRecipients.length > 1;

    const firstListName = allRecipients[0] || '';
    const isPaid = includes(paidListNames, firstListName) && !includes(segmentNames, firstListName);

    useEffect(() => {
        const checkTruncation = () => {
            if (textRef.current) {
                const element = textRef.current;
                setIsTextTruncated(element.scrollWidth > element.clientWidth);
            }
        };

        checkTruncation();
        window.addEventListener('resize', checkTruncation);
        return () => window.removeEventListener('resize', checkTruncation);
    }, [firstListName]);

    if (allRecipients.length === 0) {
        return null;
    }

    return (
        <RecipientsContainer $hasMultipleItems={hasMultipleItems} $isMobile={isMobile}>
            {isPaid && <PaidNewsletterIcon color={isMobile ? palette.gray[7] : palette.gray[5]} width={18} height={18} />}
            <RecipientText 
                ref={textRef}
                $hasMultipleItems={hasMultipleItems}
                $isPaid={isPaid}
            >
                {firstListName}
            </RecipientText>
            {hasMultipleItems && !isTextTruncated && (
                <RecipientEllipsis>
                    ,...
                </RecipientEllipsis>
            )}
        </RecipientsContainer>
    );
};